var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantLogoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9961 36H26.9902V34H20.9961V36Z",
    fill: "#919194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9883 33H20.9961V31H28.9883V33Z",
    fill: "#919194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9963 18H17V40H40.9963V18ZM24.9988 24.875V19.925H18.8664V38.075H39.1299V19.925H32.9975V24.875H24.9988ZM31.1311 22.95H26.8651V19.925H31.1311V22.95Z",
    fill: "#919194"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantLogoPlaceholder);
export default __webpack_public_path__ + "static/media/merchant-logo-placeholder.792050941e3480905e5694ca05215b04.svg";
export { ForwardRef as ReactComponent };